import { BasePluginData } from './base-plugin-data';

/**
 * Represents the data model for template details in a resource request wizard plugin
 */
export class TemplateDetailsData extends BasePluginData {
  override get pluginStepName(): string { return 'TemplateDetailsData'; }

  /**
   * The name of the template being used for the resource request
   */
  templateName: string = '';

  /**
   * The description of the template being used for the resource request
   */
  templateDescription?: string = '';
}
